/**
 * THE HAPPINESS STORY — Cart Drawer JS v2
 * Handles: open/close, fetch cart state, update quantities, remove items.
 * All mutations use Shopify Cart AJAX API.
 */

(function () {
  'use strict';

  var drawer = document.getElementById('ths2-cart-drawer');
  var overlay = document.getElementById('ths2-cart-overlay');
  var closeBtn = document.getElementById('ths2-cart-close');
  var cartBody = document.getElementById('ths2-cart-body');
  var itemsEl = document.getElementById('ths2-cart-items');
  var emptyEl = document.getElementById('ths2-cart-empty');
  var footerEl = document.getElementById('ths2-cart-footer');
  var subtotalEl = document.getElementById('ths2-cart-subtotal');
  var countEl = document.getElementById('ths2-cart-drawer-count');

  /* ── Open / Close ───────────────────────────────────────────── */
  function openCart() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    fetchCart();
  }

  function closeCart() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  if (closeBtn) closeBtn.addEventListener('click', closeCart);
  if (overlay) overlay.addEventListener('click', closeCart);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) {
      closeCart();
    }
  });

  /* ── Fetch & Render Cart ─────────────────────────────────────── */
  function formatMoney(cents) {
    return '₹' + (cents / 100).toLocaleString('en-IN');
  }

  function renderCart(cart) {
    if (!itemsEl || !emptyEl || !footerEl) return;

    if (cart.item_count === 0) {
      emptyEl.style.display = 'block';
      itemsEl.style.display = 'none';
      footerEl.style.display = 'none';
      if (countEl) countEl.textContent = '';
      return;
    }

    emptyEl.style.display = 'none';
    itemsEl.style.display = 'flex';
    footerEl.style.display = 'block';
    if (countEl) countEl.textContent = '(' + cart.item_count + ' item' + (cart.item_count > 1 ? 's' : '') + ')';
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

    itemsEl.innerHTML = cart.items.map(function (item) {
      var img = item.image
        ? '<img src="' + item.image + '" alt="' + item.title + '" loading="lazy" width="72" height="72">'
        : '';
      return (
        '<div class="ths2-cart__item" data-key="' + item.key + '">' +
          '<div class="ths2-cart__item-img">' + img + '</div>' +
          '<div class="ths2-cart__item-info">' +
            '<p class="ths2-cart__item-name">' + item.product_title + '</p>' +
            (item.variant_title && item.variant_title !== 'Default Title'
              ? '<p class="ths2-cart__item-variant">' + item.variant_title + '</p>'
              : '') +
            '<div class="ths2-cart__item-row">' +
              '<span class="ths2-cart__item-price">' + formatMoney(item.line_price) + '</span>' +
              '<div class="ths2-cart__item-qty">' +
                '<button class="ths2-cart__qty-btn" data-action="dec" data-key="' + item.key + '" aria-label="Remove one">−</button>' +
                '<span class="ths2-cart__qty-num">' + item.quantity + '</span>' +
                '<button class="ths2-cart__qty-btn" data-action="inc" data-key="' + item.key + '" aria-label="Add one">+</button>' +
                '<button class="ths2-cart__item-remove" data-key="' + item.key + '" aria-label="Remove item">×</button>' +
              '</div>' +
            '</div>' +
          '</div>' +
        '</div>'
      );
    }).join('');

    /* Wire up buttons */
    itemsEl.querySelectorAll('.ths2-cart__qty-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-key');
        var action = btn.getAttribute('data-action');
        var item = cart.items.find(function (i) { return i.key === key; });
        if (!item) return;
        var newQty = action === 'inc' ? item.quantity + 1 : item.quantity - 1;
        updateItem(key, Math.max(0, newQty));
      });
    });

    itemsEl.querySelectorAll('.ths2-cart__item-remove').forEach(function (btn) {
      btn.addEventListener('click', function () {
        updateItem(btn.getAttribute('data-key'), 0);
      });
    });

    /* Dispatch for header count update */
    document.dispatchEvent(new CustomEvent('ths2:cart-updated', { detail: cart }));
  }

  function fetchCart() {
    if (cartBody) cartBody.setAttribute('aria-busy', 'true');
    fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderCart(cart);
        if (cartBody) cartBody.removeAttribute('aria-busy');
      })
      .catch(function () {
        if (cartBody) cartBody.removeAttribute('aria-busy');
      });
  }

  function updateItem(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function () {});
  }

  /* ── Add to cart (called from product pages) ─────────────────── */
  window.ths2AddToCart = function (variantId, quantity, properties) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: variantId,
        quantity: quantity || 1,
        properties: properties || {}
      })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        openCart();
      })
      .catch(function () {
        /* Fallback: redirect to cart */
        window.location.href = '/cart';
      });
  };

  /* ── Open cart drawer on header cart button ──────────────────── */
  document.addEventListener('click', function (e) {
    var cartBtn = e.target.closest('#ths2-cart-btn');
    if (cartBtn) {
      e.preventDefault();
      openCart();
    }
  });

  /* ── Initial fetch for cart count ───────────────────────────── */
  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      document.dispatchEvent(new CustomEvent('ths2:cart-updated', { detail: cart }));
    })
    .catch(function () {});

})();
